import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import { Phone } from '@material-ui/icons';
import clsx from 'clsx';

import TextButton from '../TextButton';
import { breakpoints } from '../../../Core/Theme';

const PhoneButton = props => {
  const { phoneNumber, classes, className } = props;

  return phoneNumber ? (
    <TextButton
      text={
        <div className={classes.content}>
          <Phone className={classes.icon} />
          <div className={classes.phoneNumber}>{phoneNumber}</div>
        </div>
      }
      onClick={() => window.open(`tel:${phoneNumber}`)}
      className={clsx([classes.button, className])}
    />
  ) : null;
};

const styles = theme => ({
  button: {
    fontFamily: 'VerlagBook',
    fontSize: 16,
  },
  icon: {
    height: 15,
    padding: 0,
    paddingTop: 3,
  },
  phoneNumber: {
    display: 'none',
    [theme.breakpoints.up(breakpoints.MOBILE)]: {
      display: 'block',
    },
  },
  content: {
    overflowWrap: 'anywhere',
    display: 'flex',
    textAlign: 'left',
  },
});
PhoneButton.defaultProps = {
  phoneNumber: null,
};

PhoneButton.propTypes = {
  phoneNumber: PropTypes.number,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(PhoneButton);
